const { Map } = require('immutable');

const addCryptoContracts = (contractList, immJointContracts) => {
  if (contractList && contractList.get('crypto')) {
    const updatedImmJointContracts = immJointContracts.update('byId', byId => {
      return byId.merge(
        Map(
          contractList.get('crypto').reduce((acc, cryptoItem) => {
            const id = cryptoItem.get ? cryptoItem.get('id') : cryptoItem.id;
            if (id) {
              acc[id] = cryptoItem;
            } else {
              console.error('El objeto cryptoItem no tiene un identificador válido:', cryptoItem);
            }
            return acc;
          }, {})
        )
      );
    });

    return updatedImmJointContracts;
  } else {
    console.error('contractList o contractList.crypto no está definido o no es válido');
  }
};

module.exports = {
  addCryptoContracts,
};
